import React, { useState } from 'react';
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai'

const CollapsibleElement = ({ title, paragraphs }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div className='md:w-[600px] w-[375px] p-2 bg-primary cursor-pointer rounded-lg' onClick={handleToggle}>
      <button className='p-2 text-gradient w-full flex flex-row justify-between items-center'>
        <span>{title}</span>

        <span>
            {
                !expanded ? <AiFillCaretDown className='text-white' fontSize={20}/> : <AiFillCaretUp className='text-white' fontSize={20}/>
            }
            
        </span>
      </button>
      {expanded && (
        <div className='text-white flex text-justify flex-col gap-y-3 p-2 mt-2 w-full'>
            <hr />
          {paragraphs.map((paragraph, index) => (
            <p key={index}>-{paragraph}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default CollapsibleElement;
